import React, {
  Fragment,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
  useCallback,
  useMemo,
} from "react";
import {
  BackgroundDiv,
  BottomBtnArea,
  BtnRadio,
  ContentBody,
  ContentBody2,
  DivSelectBoxArea,
  DivSelectBoxTitle,
  FlexDiv,
  HeaderTitle,
  NoticeText,
  SelectDivArea,
} from "./ReceiptStyle";

import { Button } from "../../../components";
import { AppContext } from "../../../components/AppProvider";
import { checkHour12, checkNum10 } from "../../../modules/utils/CheckLogic";
import { IC } from "../../../resources/Assets";
import CommonNoticeText from "../../common/NoticeText/CommonNoticeText";
import { getRsrvDrList, getRsrvTimeList } from "../Interface/NFTF/getRsrvData";
import InnerDivCpnt from "./InnerDivCpnt";
import SelectDropCpnt from "./SelectDropCpnt";
import { LoadingLayer } from "../../common/Layer/Loading";

// POST DATA: {view: "", data: ""}
// const [postAmPm, setPostAmPm] = useState(
//   hsptInfo
//     ? { view: hsptInfo.ampm == "am" ? "오전" : "오후", data: hsptInfo.ampm }
//     : new Date().getHours() < 12
//     ? { view: "오전", data: "am" }
//     : { view: "오후", data: "pm" }
// );

const ReceiptTime = props => {
  const {
    setHsptInfo,
    hsptInfo,
    minTerms,
    startTime,
    endTime,
    backStep,
    handleDialog,
    hsptData,
  } = props;
  const { userinfo, cfg, phonecfg, nftfDoctor } = useContext(AppContext);

  const [postAmPm, setPostAmPm] = useState(
    hsptInfo && {
      view: hsptInfo.ampm == "am" ? "오전" : "오후",
      data: hsptInfo.ampm,
    }
  );

  const [postHour, setPostHour] = useState(
    hsptInfo && { view: checkHour12(hsptInfo.hour), data: hsptInfo.hour }
  );
  const [postMin, setPostMin] = useState(
    hsptInfo && { view: hsptInfo.min, data: hsptInfo.min }
  );
  // const [postDoctor, setPostDoctor] = useState(hsptInfo && hsptInfo.doctor);
  const [postDoctor, setPostDoctor] = useState(
    hsptInfo
      ? hsptInfo.doctor
      : nftfDoctor != null && {
          doctorName: nftfDoctor.doctor[0].doctorName,
          doctorLicense: nftfDoctor.doctor[0].license,
          startHour: nftfDoctor.doctor[0].startTime,
          endHour: nftfDoctor.doctor[0].endTime,
          view: nftfDoctor.doctor[0].DrName,
          data: nftfDoctor.doctor[0].license,
        }
  );

  const [rqstDoctorList, setRqstDoctorList] = useState(null);
  const [showAmPmArr, setShowAmPmArr] = useState([]);
  const [showTimeArr, setShowTimeArr] = useState([]);
  const [showMinArr, setShowMinArr] = useState([]);

  const [startHour, setStartHour] = useState(startTime);
  const [endHour, setEndHour] = useState(endTime);

  const [openTarget, setOpenTarget] = useState(null);

  const [timeList, setTimeList] = useState([]);

  // interface 275 진료가능의사
  // interface 276 진료가능시간
  const setAmpmArray = timeList => {
    let returnData = [];

    if (parseInt(timeList[0].appHour) < 12) {
      returnData.push({
        view: "오전",
        data: "am",
      });
    }

    if (parseInt(timeList[timeList.length - 1].appHour) > 11) {
      returnData.push({
        view: "오후",
        data: "pm",
      });
    }

    setPostAmPm(
      hsptInfo
        ? hsptInfo.ampm === "am"
          ? returnData[0]
          : returnData[returnData.length - 1]
        : returnData[0]
    );
    setShowAmPmArr(returnData);
  };

  const setTimeArray = timeList => {
    let returnData = new Array();
    for (let i = 0; i < timeList.length; i++) {
      if (postAmPm.data === "am") {
        if (parseInt(timeList[i].appHour) > 11) {
          break;
        }
      } else if (postAmPm.data === "pm") {
        if (parseInt(timeList[i].appHour) < 12) {
          continue;
        }
      }

      if (i > 0) {
        if (timeList[i].appHour === timeList[i - 1].appHour) {
          continue;
        }
      }

      returnData.push({
        view: checkNum10(timeList[i].appHour),
        data: checkNum10(parseInt(timeList[i].appHour)),
      });
    }
    setShowTimeArr(returnData);
  };

  const setMinArray = dataArr => {
    let returnData = [];
    let forStartIdx = 0;

    if (dataArr.length > 0) {
      for (let i = 0; i < dataArr.length; i++) {
        returnData.push({
          view: dataArr[i].appMin,
          data: dataArr[i].appMin,
        });
      }
    } else {
      let selectHour = parseInt(postHour.data);

      for (let i = forStartIdx; i < 60; i = i + parseInt(minTerms)) {
        if (new Date().getHours() === selectHour) {
          // 현재 분보다 작은 데이터 제거
          if (new Date().getMinutes() < i) {
            returnData.push({
              view: checkNum10(i),
              data: checkNum10(i),
            });
          }
        } else {
          returnData.push({
            view: checkNum10(i),
            data: checkNum10(i),
          });
        }
      }
    }
    setShowMinArr(returnData);
  };

  useEffect(() => {
    props.setMsgState("time");
    getRsrvDrList(
      userinfo,
      cfg,
      phonecfg,
      props.hpKey,
      setRqstDoctorList,
      props.startTime,
      props.endTime,
      hsptData.appDr
    );
  }, []);

  useEffect(() => {
    getRsrvTimeList(
      userinfo,
      cfg,
      phonecfg,
      props.hpKey,
      postDoctor ? postDoctor.data : "미지정",
      // postDoctor ? postDoctor.data : nftfDoctor != null ? nftfDoctor.doctor[0].license : "미지정",
      postHour ? postHour.data : "00",
      "1",
      setTimeList,
      setAmpmArray,
      setTimeArray
      // setMinArray
    );
    // }, [postDoctor, postAmPm]);
  }, [postDoctor]);

  useEffect(() => {
    if (timeList && timeList.length > 0 && postAmPm) {
      setTimeArray(timeList);
    }
  }, [timeList, postAmPm]);

  useEffect(() => {
    if (timeList.length > 0 && postHour) {
      setMinArray(timeList.filter(e => e.appHour === postHour.view));
    }
  }, [timeList, postHour]);

  useEffect(() => {
    if (timeList && timeList.length > 0) {
      setAmpmArray(timeList);
    }
  }, [postDoctor, timeList]);

  // useCallback 적용
  const selectDoctor = useCallback(data => {
    resetPostData();
    setPostDoctor(data);
    setStartHour(data.startHour);
    setEndHour(data.endHour);
  }, []);

  const resetPostData = () => {
    setPostAmPm(false);
    setPostHour(false);
    setPostMin(false);
  };

  const selectAmPm = useCallback(data => {
    resetPostData();
    setPostAmPm(data);
  }, []);

  const selectPostHour = useCallback(
    hour => {
      if (hour != postHour) {
        setPostMin(false);
      }
      setPostHour(hour);
    },
    [postHour]
  );

  // useMemo 적용
  const amPmOptions = useMemo(() => showAmPmArr, [showAmPmArr]);
  const timeOptions = useMemo(() => showTimeArr, [showTimeArr]);
  const minOptions = useMemo(
    () => (postHour ? showMinArr : ""),
    [postHour, showMinArr]
  );

  const checkAmPm = data => {
    if (postAmPm && postAmPm.data === data.data) {
      return true;
    } else {
      return false;
    }
  };

  const submit = () => {
    setHsptInfo({
      ampm: postAmPm.data,
      hour: postHour.data,
      min: postMin.data,
      doctor: {
        doctorName: postDoctor
          ? postDoctor.view
            ? postDoctor.view
            : postDoctor.doctorName
          : "미지정",
        doctorLicense: postDoctor
          ? postDoctor.data
            ? postDoctor.data
            : postDoctor.doctorLicense
          : "미지정",
        startHour: postDoctor ? postDoctor.startHour : startTime,
        endHour: postDoctor ? postDoctor.endHour : endTime,
        view: postDoctor ? postDoctor.view : "미지정",
        data: postDoctor ? postDoctor.data : "미지정",
      },
    });

    if (backStep) {
      props.setPageIdx(1);
    } else {
      props.setPageIdx(4);
    }
  };

  const defaultDataSetting = () => {
    try {
      getRsrvTimeList(
        userinfo,
        cfg,
        phonecfg,
        props.hpKey,
        postDoctor ? postDoctor.data : "미지정",
        // postDoctor ? postDoctor.data : nftfDoctor != null ? nftfDoctor.doctor[0].license : "미지정",
        postHour ? postHour.data : "00",
        "1",
        setTimeList,
        setAmpmArray,
        setTimeArray
        // setMinArray
      );
    } catch (error) {}
  };

  // 준비 상태 체크
  const isReady = useMemo(() => {
    return (
      rqstDoctorList &&
      amPmOptions &&
      amPmOptions.length > 0 &&
      timeOptions &&
      timeOptions.length > 0
      // minOptions && minOptions.length > 0 // 조건 완화
    );
  }, [rqstDoctorList, amPmOptions, timeOptions /*, minOptions*/]);

  if (!isReady) {
    return (
      // <div
      //   style={{
      //     width: "100%",
      //     height: "300px",
      //     display: "flex",
      //     alignItems: "center",
      //     justifyContent: "center",
      //   }}>
      //   로딩중...
      // </div>

      <LoadingLayer />
    );
  }

  return (
    <Fragment>
      <BackgroundDiv>
        <HeaderTitle>
          <div
            style={{ width: "40px", height: "40px" }}
            onClick={() => props.setPageIdx(1)}>
            <img src={IC.etc.ICON_CHEVRON_LEFT} />
          </div>
          {/* <div>진료시간 및 의료진 선택</div> */}
          <div>{props.hederTitle}</div>
          <div style={{ width: "40px", height: "40px" }}>
            {/* <img src={ArrowLeft} /> */}
          </div>
        </HeaderTitle>
        <ContentBody>
          <NoticeText>
            진료받으실
            <br />
            시간을 선택해주세요
          </NoticeText>

          <ContentBody2>
            <SelectDropCpnt
              title={"의료진 선택"}
              placeHolder={"의료진을 선택하세요"}
              options={rqstDoctorList}
              viewData={postDoctor}
              setData={selectDoctor}
              openTarget={openTarget}
              setOpenTarget={setOpenTarget}
            />

            <SelectDivArea>
              <DivSelectBoxTitle>시간선택</DivSelectBoxTitle>

              <FlexDiv>
                {amPmOptions &&
                  amPmOptions.map(m => (
                    <BtnRadio
                      key={m.data}
                      onClick={() => selectAmPm(m)}
                      checked={checkAmPm(m)}>
                      {m.view}
                    </BtnRadio>
                  ))}
              </FlexDiv>

              <DivSelectBoxArea>
                <InnerDivCpnt
                  placeHolder="시간"
                  options={timeOptions}
                  viewData={postHour}
                  setData={selectPostHour}
                  cpmtTarget={"HOUR"}
                  openTarget={openTarget}
                  setOpenTarget={setOpenTarget}
                  handleDialog={handleDialog}
                  // setData={setPostHour}
                />
                <InnerDivCpnt
                  placeHolder="분"
                  options={minOptions}
                  viewData={postMin}
                  setData={setPostMin}
                  cpmtTarget={"MIN"}
                  openTarget={openTarget}
                  setOpenTarget={setOpenTarget}
                  handleDialog={handleDialog}
                />
              </DivSelectBoxArea>
              <CommonNoticeText
                title="비대면진료는 당일 예약만 가능합니다"
                text=""
              />
            </SelectDivArea>
          </ContentBody2>
        </ContentBody>
        {/* {postAmPm && postHour && postMin && ( */}
        <BottomBtnArea>
          <Button
            severity="primary"
            disable={"off"}
            // disable="on"
            clickEvent={() =>
              postAmPm && postHour && postMin
                ? submit()
                : props.setViewMsgLayer(true)
            }>
            {backStep ? "저장" : "저장 후 다음"}
          </Button>
        </BottomBtnArea>
        {/* )} */}
      </BackgroundDiv>
    </Fragment>
  );
};

export default ReceiptTime;
